<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
      <el-breadcrumb-item>资讯列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 顶部筛选条件 -->
      <el-row :gutter="20" style="margin-bottom: 12px;">
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">分类：</span>
            <el-select v-model="queryInfo.category_id" placeholder="选择分类" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option v-for="item in categoryOptions" :key="item.id" :label="item.title" :value="item.id" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">类型：</span>
            <el-select v-model="queryInfo.type" placeholder="选择类型" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option label="纯文字" :value="0" />
              <el-option label="左标题右图" :value="1" />
              <el-option label="上标题下三图" :value="2" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">状态：</span>
            <el-select v-model="queryInfo.status" placeholder="选择状态" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option label="不显示" :value="0" />
              <el-option label="显示" :value="1" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">置顶：</span>
            <el-select v-model="queryInfo.isInTop" placeholder="选择置顶状态" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option label="否" :value="0" />
              <el-option label="是" :value="1" />
            </el-select>
          </div>
        </el-col>
      </el-row>

      <!-- 搜索与新增 -->
      <el-row :gutter="24" style="margin-bottom: 8px;">
        <el-col :span="8">
          <el-input placeholder="请输入资讯标题" v-model="queryInfo.query" clearable @clear="getList">
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="goAddPage">新增资讯</el-button>
        </el-col>
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="list" border stripe class="compact-table" size="mini">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column label="ID" prop="id" width="70"></el-table-column>
        <el-table-column label="基本信息" width="280">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
              <el-col :span="24"><strong>{{ scope.row.title }}</strong></el-col>
              <el-col :span="24" class="sub-info">作者：{{ scope.row.author || '-' }}</el-col>
              <el-col :span="24" class="sub-info">分类：{{ scope.row.category_name || '-' }}</el-col>
              <el-col :span="24" class="sub-info">角标：{{ scope.row.mark || '-' }}</el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="封面" width="130" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.fengmian_urls">
              <el-image 
                v-for="(img, idx) in parseFengmianUrls(scope.row.fengmian_urls).slice(0, 1)" 
                :key="idx"
                style="width: 80px; height: 60px; margin: 2px;" 
                :src="img" 
                fit="cover" 
                :preview-src-list="parseFengmianUrls(scope.row.fengmian_urls)"
              ></el-image>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column label="类型/状态" width="150">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
              <el-col :span="24">
                类型：
                <el-tag size="mini" v-if="scope.row.type === 0">纯文字</el-tag>
                <el-tag size="mini" type="success" v-else-if="scope.row.type === 1">左标题右图</el-tag>
                <el-tag size="mini" type="warning" v-else-if="scope.row.type === 2">上标题下三图</el-tag>
              </el-col>
              <el-col :span="24" class="status-row">
                状态：
                <span class="status-badge on" v-if="scope.row.status === 1">显示</span>
                <span class="status-badge off" v-else>不显示</span>
              </el-col>
              <el-col :span="24">
                置顶：
                <el-tag size="mini" type="danger" v-if="scope.row.isInTop === 1">是</el-tag>
                <el-tag size="mini" type="info" v-else>否</el-tag>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="统计数据" width="150">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
              <el-col :span="24">点击：{{ scope.row.click_count || 0 }}</el-col>
              <el-col :span="24">分享：{{ scope.row.share_count || 0 }}</el-col>
              <el-col :span="24">收藏：{{ scope.row.collection_count || 0 }}</el-col>
              <el-col :span="24">排序：{{ scope.row.sort || 0 }}</el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="时间" width="180">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
              <el-col :span="24">创建：{{ scope.row.create_time }}</el-col>
              <el-col :span="24">更新：{{ scope.row.update_time }}</el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="goEditPage(scope.row.id)">编辑</el-button>
            <el-button type="warning" icon="el-icon-view" size="mini" @click="shangjia(scope.row.id)" v-if="scope.row.status === 0">上架</el-button>
            <el-button type="danger" icon="el-icon-close" size="mini" @click="xiajia(scope.row.id)" v-if="scope.row.status === 1">下架</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        query: '',
        page: 1,
        page_size: 20,
        category_id: null,
        type: null,
        status: null,
        isInTop: null
      },
      list: [],
      total: 0,
      categoryOptions: []
    }
  },

  created() {
    this.getList()
    this.getCategoryList()
  },

  methods: {
    // 获取资讯列表
    async getList() {
      const { data: res } = await this.$http.get('admin/z/list', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取资讯列表失败！')
      }
      this.$message.success('获取资讯列表成功！')
      this.list = res.result.items || []
      this.total = res.result.total || 0
    },

    // 获取资讯分类列表
    async getCategoryList() {
      const { data: res } = await this.$http.get('admin/zc/list')
      if (res.code !== 200) {
        return this.$message.error('获取资讯分类列表失败！')
      }
      this.categoryOptions = res.result.items || res.result || []
    },

    // 解析封面图片数组
    parseFengmianUrls(urlsStr) {
      if (!urlsStr) return []
      try {
        const parsed = JSON.parse(urlsStr)
        return Array.isArray(parsed) ? parsed : [urlsStr]
      } catch {
        return urlsStr.split(',').filter(u => u.trim())
      }
    },

    // 筛选条件改变
    handleFilterChange() {
      this.queryInfo.page = 1
      this.getList()
    },

    handleSizeChange(newSize) {
      this.queryInfo.page_size = newSize
      this.getList()
    },

    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getList()
    },

    // 上架
    async shangjia(id) {
      const { data: res } = await this.$http.post('admin/z/edit', { id, status: 1 })
      if (res.code !== 200) {
        return this.$message.error('上架失败！')
      }
      this.$message.success('上架成功！')
      this.getList()
    },

    // 下架
    async xiajia(id) {
      const confirmResult = await this.$confirm('此操作将下架该资讯, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消下架！')
      }
      const { data: res } = await this.$http.post('admin/z/edit', { id, status: 0 })
      if (res.code !== 200) {
        return this.$message.error('下架失败！')
      }
      this.$message.success('下架成功！')
      this.getList()
    },

    goAddPage() {
      this.$router.push('/zixunEdit')
    },

    goEditPage(id) {
      this.$router.push({ path: '/zixunEdit', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.multiline-cell {
  white-space: normal;
  word-break: break-word;
  line-height: 22px;
}

.sub-info {
  color: #909399;
  font-size: 12px;
}

.compact-table {
  font-size: 13px;
}

.status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-badge.off {
  background: #f56c6c;
}

.status-badge.on {
  background: #67c23a;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  color: #606266;
  white-space: nowrap;
}
</style>
